import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  helpCount: 0,
  wrongCount: 0,
  isShowingItemFeedback: false,
  submittedAnswerCounts: {},
};

const submittedAnswersReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        submittedAnswerCounts: {},
      };
    case REDUX_ACTIONS.INITIALIZE_ITEM:
      return {
        ...state,
        wrongCount: 0,
        helpCount: 0,
        isShowingItemFeedback: false,
      };
    case REDUX_ACTIONS.INCREMENT_HELP_COUNT:
      return {
        ...state,
        helpCount: state.helpCount + 1,
      };
    case REDUX_ACTIONS.MARK_ITEM_AS_COMPLETE:
      return {
        ...state,
        isShowingItemFeedback: true,
      };
    case REDUX_ACTIONS.INCREMENT_SUBMITTED_ANSWERS_COUNT: {
      const submittedAnswerCounts = { ...state.submittedAnswerCounts };

      if (submittedAnswerCounts[payload.contentId] === undefined) {
        submittedAnswerCounts[payload.contentId] = 0;
      }
      submittedAnswerCounts[payload.contentId] += 1;

      return {
        ...state,
        submittedAnswerCounts,
      };
    }
    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT:
      return {
        ...state,
        wrongCount: state.wrongCount + 1,
      };
    default:
      return state;
  }
};

export default submittedAnswersReducer;
